/* StatusFlowComponent.js */

"use strict";
const _ = require("lodash");
const EventEmitter = require("events").EventEmitter;
const Renderer = require("./StatusFlowRenderer");

class StatusFlowComponent extends EventEmitter {
    constructor(config) {
        super();
        const defaultConfig = {
            flowPoints: ["Draft", "Run"],
            draft: {
                default: {
                    label: "Draft",
                    class: "",
                },
                ready: {
                    label: "Ready",
                    class: "success",
                },
            },
            run: {
                default: {
                    label: "Run",
                    class: "",
                },
                success: {
                    label: "Run",
                    class: "success",
                },
                error: {
                    label: "Run",
                    class: "error",
                },
                canceled: {
                    label: "Run",
                    class: "",
                },
                scheduled: {
                    label: "Run",
                    class: "scheduled",
                },
                running: {
                    label: "Run",
                    class: "running",
                },
                canceling: {
                    label: "Cancel",
                    class: "running",
                },
            },
        };
        this._config = _.extend({}, defaultConfig, config);

        this._flowPoints = this._config.flowPoints;
        this._registerListeners();
        this._renderer = new Renderer(this);
    }
    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS */
    /*******************************************/
    _registerListeners() {}
    _unregisterListeners() {}
    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS */
    /* START PUBLIC COMPONENT MODEL METHODS */
    /*******************************************/
    get renderer() {
        return this.getRenderer();
    }
    getRenderer() {
        return this._renderer;
    }
    shutdown() {
        this._unregisterListeners();
        let prom = this._renderer.shutdown().then(() => {
            this._renderer = undefined;
            this._config = undefined;
            this._flowPoints = undefined;
        });
        return prom;
    }
    /*******************************************/
    /* END COMPONENT MODEL METHODS */
    /* START HANDLER METHODS */
    /*******************************************/

    /*******************************************/
    /* END HANDLER METHODS */
    /* START PRIVATE METHODS */
    /*******************************************/

    /*******************************************/
    /* END PRIVATE METHODS */
    /* START PUBLIC API METHODS */
    /*******************************************/
    setState(flowPoint, state) {
        this.emit("setState", {flowPoint, state});
    }

    resetAll() {
        this.emit("resetAllStates");
    }
    /*******************************************/
    /* END PUBLIC API METHODS */
    /*******************************************/
}
module.exports = StatusFlowComponent;
